import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Support from "@app.automotus.io/components/routes/support";
import { SupportChat } from "./SupportChat";

/**
 * Authenticated users get the full-screen Zendesk chat; everyone else keeps
 * the existing redirect-to-Help-Center behavior that many guest flows rely on.
 */
export const SupportRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isAuthenticated && !isLoading) {
    return <SupportChat />;
  }

  return <Support />;
};

export default SupportRoute;
